import {
  Button,
  Card,
  CardBody,
  Chip,
  Tooltip,
} from "@material-tailwind/react";
import { useNavigate } from "react-router-dom";
import { useUserStore } from "../../../Context/store";
import { getLocalTime } from "../../../Utils/Helper";
import MotionChip from "../Chip/MotionChip";

const ActiveCard = ({
  post,
  isDraft = false,
  isOpen = false,
  isPending = false,
}) => {
  const accountPreference = post?.isPublic
    ? "public"
    : post?.isSemiPublic
    ? "semipublic"
    : "private";
  const navigate = useNavigate();
  const { user } = useUserStore();
  const isCreator = post?.creatorId === user?.userId;

  const handleClickCard = async (e) => {
    e.stopPropagation();
    if (isPending) {
      navigate(
        `/update-debate?from=pending&activeState=2&debateId=${post?.debateId}`,
        {
          state: {
            selectedDebate: {
              debateId: post?.debateId,
              MotionOrClaim: post?.motionAndClaim,
              Fields: post?.category,
              IsDebateSemiPublic: post?.isSemiPublic,
              IsDebatePublic: post?.isPublic,
              IsDebatePrivate: post?.isPrivate,
              Type: post?.debateType,
              CreatorOpeningArgument: post?.creatorArgument,
              SideForDebate: post?.sideForDebate
                ? post?.sideForDebate.charAt(0).toUpperCase() +
                  post?.sideForDebate.slice(1)
                : "",
            },
          },
        }
      );
      return;
    }
    if (isOpen && post?.debateType !== "eonian") {
      navigate(`/debate/${post.debateId}?round=${post?.currentRound || 1}`, {
        state: {
          debate: post,
          category: post?.category,
          debateType: post?.debateType,
        },
      });
      return;
    }
    if (isDraft) {
      navigate(
        `/createDebate?from=draft&activeState=2&debateId=${post?.debateId}`,
        {
          state: {
            selectedDebate: {
              debateId: post?.debateId,
              MotionOrClaim: post?.motionAndClaim,
              Fields: post?.category,
              IsDebateSemiPublic: post?.isSemiPublic,
              IsDebatePublic: post?.isPublic,
              IsDebatePrivate: post?.isPrivate,
              Type: post?.debateType,
              CreatorOpeningArgument: post?.creatorArgument,
              SideForDebate: post?.sideForDebate,
              DebateImage: post?.creatorDebateImage,
            },
          },
        }
      );
      return;
    }
    if (post?.debateType === "eonian") {
      navigate(`/debate/${post?.debateId}?round=${0}`, {
        state: {
          debate: post,
          category: post?.category,
          debateType: post?.debateType,
        },
      });
      return;
    }
    navigate(`/debate/${post?.debateId}?round=${post?.currentRound || 1}`, {
      state: {
        debate: post,
        category: post?.category,
        debateType: post?.debateType,
      },
    });
  };

  const handleClick = async (e) => {
    if (isPending) {
      navigate(
        `/update-debate?from=pending&activeState=2&debateId=${post?.debateId}`,
        {
          state: {
            selectedDebate: {
              debateId: post?.debateId,
              MotionOrClaim: post?.motionAndClaim,
              Fields: post?.category,
              IsDebateSemiPublic: post?.isSemiPublic,
              IsDebatePublic: post?.isPublic,
              IsDebatePrivate: post?.isPrivate,
              Type: post?.debateType,
              CreatorOpeningArgument: post?.creatorArgument,
              SideForDebate: post?.sideForDebate
                ? post?.sideForDebate.charAt(0).toUpperCase() +
                  post?.sideForDebate.slice(1)
                : "",
            },
          },
        }
      );
      return;
    }
    if (
      post?.debateType === "eonian" &&
      !isDraft &&
      !isOpen &&
      post?.isUserTurn
    ) {
      isCreator
        ? navigate(
            `/debate/${
              post?.debateId
            }/add-argument?roundNo=${0}&isNextRound=true&userName=Add Argument`
          )
        : navigate(
            `/debate/${post?.debateId}/add-argument?userName=Add Argument&isAddPhoto=false`
          );
      return;
    }
    if (post?.debateType === "eonian" && !isDraft && !post?.isUserTurn) {
      navigate(`/debate/${post?.debateId}?round=${0}`, {
        state: {
          debate: post,
          category: post?.category,
          debateType: post?.debateType,
        },
      });
      return;
    }
    if (isOpen) {
      if (post?.debateStatus === "completed") {
        navigate(`/debate-results/${post?.debateId}`);
        return;
      }
      if (post?.debateType === "eonian") {
        navigate(`/debate/${post?.debateId}?round=${0}`, {
          state: {
            debate: post,
            category: post?.category,
            debateType: post?.debateType,
          },
        });
        return;
      }
      navigate(`/debate/${post.debateId}?round=${post?.currentRound || 1}`, {
        state: {
          debate: post,
          category: post?.category,
          debateType: post?.debateType,
        },
      });
      return;
    }
    if (isDraft) {
      navigate(
        `/createDebate?from=draft&activeState=2&debateId=${post?.debateId}`,
        {
          state: {
            selectedDebate: {
              debateId: post?.debateId,
              MotionOrClaim: post?.motionAndClaim,
              Fields: post?.category,
              IsDebateSemiPublic: post?.isSemiPublic,
              IsDebatePublic: post?.isPublic,
              IsDebatePrivate: post?.isPrivate,
              Type: post?.debateType,
              CreatorOpeningArgument: post?.creatorArgument,
              SideForDebate: post?.sideForDebate,
              DebateImage: post?.creatorDebateImage,
            },
          },
        }
      );
      return;
    }
    navigate(`/debate-results/${post?.debateId}`);
  };
  return (
    <div className="flex flex-col gap-2">
      <Card
        shadow={false}
        className="w-full px-2 rounded-md cursor-pointer  flex-col sm:flex-row items-center justify-center sm:items-stretch "
        onClick={handleClickCard}
      >
        <CardBody className="flex md:flex-row flex-col items-start md:items-center w-full justify-between py-1 px-0 gap-3">
          <div
            className={`flex lg:flex-row flex-col items-center gap-3 w-full `}
          >
            <MotionChip item={post?.categoryList} />
            <div className="flex flex-col">
              <p className="text-lg font-medium flex gap-1 text-debatePalette-title">
                <Tooltip
                  content={post?.motionAndClaim}
                  className="max-w-sm bg-secondary text-debatePalette-background"
                >
                  <span className="line-clamp-1">{post?.motionAndClaim}</span>
                </Tooltip>
                <span>-</span>
                <span className="text-primary">{post?.subworkspaceName}</span>
              </p>
              <div className="w-full flex gap-2 items-center">
                <Chip
                  value={post?.debateType}
                  className="bg-secondary/10 text-secondary"
                  size="sm"
                  variant="ghost"
                />
                {post?.isOtherUserAllow && (
                  <Chip
                    value={"open"}
                    className="bg-secondary/10 text-secondary"
                    size="sm"
                    variant="ghost"
                  />
                )}
              </div>
            </div>
          </div>
          <div
            className={`flex ${
              isDraft ? "flex-row" : "md:flex-col"
            } gap-3 md:items-end justify-between w-full shrink-0 md:w-auto`}
          >
            {" "}
            <Chip
              value={accountPreference}
              className={
                accountPreference === "public"
                  ? "bg-public text-publicText ml-2"
                  : accountPreference === "semipublic"
                  ? "bg-semiPublic text-semiPublicText ml-2"
                  : "bg-private text-privateText ml-2"
              }
            />
            {isDraft ? (
              <span className={`h-auto text-sm`}>
                {getLocalTime(post?.createdAt)}
              </span>
            ) : (
              <>
                {post?.debateType === "eonian" &&
                !isOpen &&
                post?.isUserTurn ? (
                  <Button
                    size="sm"
                    className="h-auto bg-secondary shrink-0"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleClick();
                    }}
                  >
                    Add new argument
                  </Button>
                ) : (
                  post?.debateType === "eonian" && (
                    <span
                      className={`capitalize cursor-pointer hover:underline h-auto ${
                        post?.debateStatus === "published"
                          ? "text-debatePalette-shadow"
                          : "text-[#1F9254]"
                      }`}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleClick();
                      }}
                    >
                      {post?.debateStatus}
                    </span>
                  )
                )}
                {post?.debateType !== "eonian" && (
                  <span
                    className={`capitalize cursor-pointer hover:underline h-auto ${
                      post?.debateStatus === "published"
                        ? "text-debatePalette-shadow"
                        : "text-[#1F9254]"
                    }`}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleClick();
                    }}
                  >
                    {post?.debateStatus}
                  </span>
                )}
              </>
            )}
          </div>
        </CardBody>
      </Card>
      <hr className="border-debatePalette-buttonBorder" />
    </div>
  );
};

export default ActiveCard;
